import { TFunction } from 'i18next';

import {
  checkboxOperators,
  listTypeOperators,
  multiListTypeOperators,
  stringOperators,
} from '../expression-builder/constants';
import {
  QueryExpressionInputType,
  QueryExpressionOperatorData,
} from '../expression-builder/types';
import { QueryExpressionTypes } from 'src/types/queryExpressionTypes';

export const INITIAL_EXPRESSION = {
  booleanOperator: 'and',
  expression: {
    expression_type: 'filter',
    field: '',
    negate: false,
    operator: '=',
    values: [],
  },
};

export const getDateOperators = (t: TFunction<'discover'>) => [
  {
    inputType: 'date_range_input' as QueryExpressionInputType,
    label: t('constants.operators.isBetween'),
    negate: false,
    value: 'between',
  },
  {
    inputType: 'text_input' as QueryExpressionInputType,
    label: t('constants.operators.isEmpty'),
    negate: false,
    value: 'empty',
  },
  {
    inputType: 'text_input' as QueryExpressionInputType,
    label: t('constants.operators.isNotEmpty'),
    negate: true,
    value: 'empty',
  },
];

export const getCvNumberOperators = (t: TFunction<'discover'>) => [
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.is'),
    negate: false,
    value: '=',
  },
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.isNot'),
    negate: true,
    value: '=',
  },
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.greaterThan'),
    negate: false,
    value: '>',
  },
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.lessThan'),
    negate: false,
    value: '<',
  },
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.isEmpty'),
    negate: false,
    value: 'empty',
  },
  {
    inputType: 'numeric_input' as QueryExpressionInputType,
    label: t('constants.operators.isNotEmpty'),
    negate: true,
    value: 'empty',
  },
];

export const getExpressionTypeToOperator = (
  t: TFunction<'discover'>,
): {
  [expressionType in QueryExpressionTypes]: Array<QueryExpressionOperatorData>;
} => ({
  CHECKBOX: checkboxOperators,
  DATE: getDateOperators(t),
  EMAIL: stringOperators,
  LIST: listTypeOperators,
  LONG_TEXT: stringOperators,
  MULTI_LIST: multiListTypeOperators,
  NUMBER: getCvNumberOperators(t),
  PHONE: stringOperators,
  SHORT_TEXT: stringOperators,
});
